import React from "react";
import { computeDisplayOrder } from "../../utils/workflowGraph";

export default function StageProgressBar({
  workflow,
  executionState,
  onStageClick,
}) {
  if (!workflow || !executionState) return null;
  const { order, cycleStageIds } = computeDisplayOrder(workflow);
  const completedIds = new Set(
    executionState.history.filter((h) => h.completedAt).map((h) => h.stageId),
  );
  const currentId = executionState.currentStageId;

  return (
    <div className="stage-progress-bar">
      {order.map((s) => {
        let cls = "future";
        if (s.id === currentId) cls = "current";
        else if (completedIds.has(s.id)) cls = "completed";
        const isClickable = completedIds.has(s.id);
        return (
          <button
            key={s.id}
            className={`stage-item ${cls}`}
            onClick={() => isClickable && onStageClick(s.id)}
            disabled={!isClickable}
            title={s.name}
          >
            <span className="stage-label">
              {s.name}
              {cycleStageIds.has(s.id) && " 🔁"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
